jQuery(document).ready(function ($) {

    var module_name = 'single_bookmaker';
});